import React from 'react';
import images from '../../../themes/appImage';
import { useSelector } from 'react-redux';
import Post from './Post';
import { imageURL } from '../../../redux/Api/apikit';

const Posts = () => {
  const { userDetailData } = useSelector(state => state.userReducer);
  const userPostData = userDetailData?.userPost;

  return (
    <div>
      <div className='flex flex-col gap-4 mt-4'>
        {userPostData && userPostData?.length > 0 ? (
          userPostData?.map(({ text, file, postType, createdAt, happyFace, partyFace, redHeart, smileyFace, smileyHeart, comment, _id }, key) => (
            <Post
              key={key}
              avatarSrc={userDetailData?.avatar ? `${imageURL}${userDetailData.avatar}` : images.defaultAvatar}
              username={userDetailData?.userName}
              time={createdAt}
              description={text}
              file={file}
              postType={postType}
              coverSrc={images.cardCover}
              commentSrc={images.commentImg}
              hugSrc={images.hug}
              happyFace={happyFace}
              partyFace={partyFace}
              redHeart={redHeart}
              smileyFace={smileyFace}
              smileyHeart={smileyHeart}
              comment={comment}
              id={_id}
            />
          ))
        ) : (
          <div className='text-center  text-black font-medium text-base'>No posts</div>
        )}
      </div>
      {/* Pagination Component */}
      {/* {userPostData?.length > 0 && (
        <div className="pagination-container mt-4">
          <Pagination 
            current={currentPage}
            total={userPostData.length} 
            pageSize={payload.limit} // Set the number of posts per page
            onChange={handlePageChange} // Handle page change event
          />
        </div>
      )} */}
    </div>
  );
}

export default Posts;
